import e from "./ConfigProvider_vue.js";
//#region src/components/ui/config-provider/ConfigProvider.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ConfigProvider.js.map